import React from 'react';

// Base checkout steps. A conditional «ΦΠΑ 39Α» step is inserted between billing
// and payment by CheckoutNext only when the cart has eligible products (it passes
// a `steps` prop). The old "review" step was removed — its gift-wrap add-on, terms
// and place-order now live at the bottom of the (final) payment step.
export const STEPS = [
  { key: 'billing', label: 'Στοιχεία αποστολής & χρέωσης' },
  { key: 'payment', label: 'Πληρωμή & ολοκλήρωση' },
];

export const STEP_TAX39A = { key: 'tax39a', label: 'ΦΠΑ 39Α (αποφορολόγηση)' };

export default function Stepper({ current, onNavigate, steps = STEPS }) {
  const currentIdx = steps.findIndex((s) => s.key === current);

  return (
    <nav className="cn-stepper" aria-label="Βήματα ολοκλήρωσης παραγγελίας">
      <ol className="cn-stepper__list">
        {steps.map((step, i) => {
          const state =
            i < currentIdx ? 'done' : i === currentIdx ? 'active' : 'upcoming';
          const clickable = i <= currentIdx && typeof onNavigate === 'function';
          return (
            <li
              key={step.key}
              className={`cn-step cn-step--${state}`}
              aria-current={state === 'active' ? 'step' : undefined}
            >
              <button
                type="button"
                className="cn-step__btn"
                disabled={!clickable}
                onClick={clickable ? () => onNavigate(step.key) : undefined}
              >
                <span className="cn-step__marker">
                  {state === 'done' ? '✓' : i + 1}
                </span>
                <span className="cn-step__label">{step.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
